import { type Ref } from 'vue-demi'
import { type EmbedElementContext } from '../../../../../element-embedder'
import { type DirectEmbedStrategySettings, type DirectLayoutModeConfig } from '../../../settings'
import { type ActivationAnalyticsEvent, type SmartblockActivationOptions, type DisableActivationInstanceEvent, SmartblockActivationOptionsInjectKey } from '@source-digital/activation-list-vue'
import { type MaybeRef, type UseElementBoundingReturn, type UseWindowSizeReturn } from '@vueuse/core'
import { type IVueActivationDetailsRenderer } from '../details/activation-details-renderer'
import { type IAnalytics } from '../../../analytics/analytics'
import { type ExperienceActivationContext, type ExperienceActivationInstance } from 'sd-types/app/experience/activation'
import { type EmbedderContext } from '../../../../../embedder'

export class BaseVueActivationTargetRenderer {
  constructor (
    public directSettings: DirectEmbedStrategySettings,
    public ctx: EmbedElementContext,
    public currentLayout: Ref<DirectLayoutModeConfig>,
    public windowSize: UseWindowSizeReturn,
    public videoElBounding: UseElementBoundingReturn,
    public detailsRenderer: IVueActivationDetailsRenderer,
    public rootClass: MaybeRef<string>,
    public createElement: (...args: Parameters<EmbedderContext['createElement']>) => ReturnType<EmbedderContext['createElement']>,
    public hide: Ref<boolean>,
    public analytics: IAnalytics
  ) { }

  createProvideObject () {
    return {
      defaultPreviewTemplate: this.currentLayout.value?.preview?.defaultTemplates?.bottom ?? this.currentLayout.value?.preview?.defaultTemplates?.default,
      [SmartblockActivationOptionsInjectKey]: {
        defaultBlockStyle: this.currentLayout.value?.targets?.bottom?.item?.blockStyle,
        defaultVersion: this.directSettings?.options?.smartblockDefaultVersion
      } satisfies SmartblockActivationOptions
    }
  }

  createDefaultListeners () {
    return {
      openDetails: ({ payload, activation, context }: { payload: any, activation: ExperienceActivationInstance, context: ExperienceActivationContext }) => {
        this.detailsRenderer.open({ activation, context })

        this.ctx.eventEmitter.emit('activation', { event: 'clicked', activation, context })
        this.analytics.sendActivationAnalytics('touch', activation)
      },
      action: ({ action, activation }) => {
        this.analytics.sendActivationAnalytics('action', activation, { action })
      },
      analytics: (data: ActivationAnalyticsEvent) => {
        this.analytics.sendActivationAnalytics(data.event, data.activation, data.payload)
      },
      'disable-instance': ({ activation }: DisableActivationInstanceEvent) => {
        this.ctx.experienceProtocol.send('updateActivationInstance', {
          id: activation.id,
          instanceId: activation.instance.id,
          activation: { instance: { active: false } }
        })
      }
    }
  }
}
